<template>
  <div class="ts-exhibition-wrapper">
    <div v-for="(item, index) in dataList" :key="index">
      <div class="ts-exhibition-label">
        {{ item.label }}
      </div>
      <div v-for="(option, idx) in item.list" :key="idx" :style="{width: option.newLine ? '100%' : ''}" :class="typeof option.value !== 'object' ? 'ts-exhibition-value' : 'ts-exhibition-list'">
        <div class="ts-exhibition-wrapper-label">
          {{ option.key }}
        </div>
        <div v-if="option.value instanceof Array && option.value.length" :class="option.key ? 'ts-exhibition-list-line' : ''">
          <el-tag v-for="(one, inx) in option.value" :key="inx" class="ts-exhibition-list-one">
            {{ one }}
          </el-tag>
        </div>
        <div v-else class="ts-exhibition-value-item">
          {{ option.value }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator'
@Component({
  name: 'TsExhibitionPage',
  components: {
  }
})
export default class extends Vue {
  @Prop({ default: Array }) dataList;
}
</script>

<style lang="scss">
  .ts-exhibition-wrapper {
    padding: 20px;
    .ts-exhibition-label {
      height: 40px;
      font-weight: bold;
      font-size: 15px;
    }
    .ts-exhibition-list {
      .ts-exhibition-list-line {
        margin: 10px 0 20px 0;
      }
      .ts-exhibition-list-one {
        margin: 0 10px 10px 0;
      }
    }
    .ts-exhibition-wrapper-label {
      font-size: 14px;
      color: #999999;
    }
    .ts-exhibition-value {
      font-size: 14px;
      width: 50%;
      display: inline-block;
      color: #999999;
      margin-bottom: 20px;
      .ts-exhibition-value-item {
        margin-top: 8px;
        color: #333333;
      }
    }
  }

</style>
